/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Box, Typography, Theme, useTheme, Divider } from '@mui/material';
import React from 'react';
import { Colors } from "../../constants/color";
// import { Icons } from '../../MediaIcon';
import { staticData } from "../../data/staticData";
import SocialMediaIcon from "../SocialMediaIcon/SocialMediaIcon";
// import { CopyrightAndSocialMedia as CopyrightAndSocialMediaProps } from '../../types/copyright_and_social_media/copyright_and_social_media.type';
// import { useFetch } from '../../utils/useFetch.utils';



const CopyrightAndSocialMedia: React.FC = (): JSX.Element => {
  const theme: Theme = useTheme();
  let year: number = new Date().getFullYear();

  const socialMedia = staticData.siteProfile.socialMedia.map((data) => {
    // const iconData = Icons.find((icon) => icon.name === data.name)
    return <SocialMediaIcon key={data.name} name={data.name} src={data.src} />
  })

  return (
    <Box
      sx={{
        width: { xs: '100%' },
        margin: { xs: theme.spacing(1, 0) },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row-reverse' },
        justifyContent: { xs: 'center', md: 'space-between' },
      }}
    >
      {/**
       * social media component
       */}
      <Box
        sx={{
          // width: { xs: '100%' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'center', md: 'flex-end' },
          // backgroundColor: 'green',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '14px' },
            margin: { xs: theme.spacing(1, 0, 0, 0) },
            paddingRight: theme.spacing(),
            color: Colors.boulder,
          }}
        >
          Social Media
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 2,
          }}
        >
          {socialMedia}
          {/* {MediaIcon(staticData?.social_media?.links!).map((elm) => {
            if (elm.url === undefined) {
              return null;
            } else {
              return (
                <Box
                  key={elm.id}
                  component='a'
                  href={elm.url}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px',
                    textDecoration: 'none',
                    color:
                      elm.url === staticData?.social_media?.links.fbLink
                        ? Colors.chambray
                        : elm.url === staticData?.social_media?.links.twiterLink
                        ? Colors.seagull
                        : elm.url === staticData?.social_media?.links.instaLink
                        ? Colors.cerise
                        : elm.url === staticData?.social_media?.links.ytLink
                        ? Colors.punch
                        : elm.url === staticData?.social_media?.links.linkedInLink
                        ? Colors.science_blue
                        : elm.url === staticData?.social_media?.links.discordLink
                        ? Colors.chetwode_blue
                        : elm.url === staticData?.social_media?.links.slackLink
                        ? Colors.fuel_yellow
                        : elm.url === staticData?.social_media?.links.whatsappLink
                        ? Colors.deep_sea_green
                        : elm.url === staticData?.social_media?.links.pinLink
                        ? Colors.monza
                        : Colors.punch,
                    cursor: 'pointer',
                  }}
                >
                  {elm.icon}
                </Box>
              );
            }
          })} */}
        </Box>
      </Box>
      {/**
       * copyright and terms and condition
       */}
      <Box
        sx={{
          width: { xs: '100%', md: 'auto' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'center', md: 'flex-start' },
          flexDirection: { xs: 'column', md: 'row-reverse' },
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: 'auto' },
            display: 'flex',
            justifyContent: { xs: 'center' },
            flexDirection: 'row',
            padding: { xs: theme.spacing(1, 0.5) },
          }}
        >
          <Typography
            component="a"
            href={staticData.termsOfUse.src}
            sx={{
              fontSize: { xs: '14px' },
              color: Colors.boulder,
              textTransform: 'capitalize',
              textDecoration: 'underline',
              '&:hover': {
                color: Colors.fallow,
                cursor: 'pointer',
              },
            }}
          >
            Terms of use
          </Typography>
          <Divider sx={{ marginInline: theme.spacing(0.5) }} orientation="vertical" flexItem />
          <Typography
            component="a"
            href={staticData.termsOfUse.src}
            sx={{
              fontSize: { xs: '14px' },
              color: Colors.boulder,
              textTransform: 'capitalize',
              textDecoration: 'underline',
              '&:hover': {
                color: Colors.fallow,
                cursor: 'pointer',
              },
            }}
          >
            Privacy Policy
          </Typography>
        </Box>
        <Box
          sx={{
            width: { xs: '100%', md: ' auto' },
            display: 'flex',
            color: Colors.boulder,
            flexDirection: {xs: "column", md: "row"},
            alignItems: "center",
            justifyContent: { xs: 'center', md: 'start' },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '14px' },
              // textAlign: "center",
            }}
          >
            Copyright &copy; {year} {staticData.siteProfile.name}.
          </Typography>
          {" "}
          <Typography>All Rights Reserved.</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CopyrightAndSocialMedia;
